import QuickReplyChip from './QuickReplyChip';

export default QuickReplyChip;
